module.exports = __webpack_public_path__ + "img/sangria-tinto-xxl.bfae8779.png";